export const capitalizarPrimeraLetra = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const obtenerNombreDia = (fecha: string): string => {
  return capitalizarPrimeraLetra(fecha);
};
